import React from 'react';
import { useRouter } from 'next/router';
import { useSetRecoilState } from 'recoil';
import styled from 'styled-components';

import SvgSelector from '@/components/Svg/SvgSelector';
import { isSearchingState } from '@/recoil/ina';
import { FontStyle } from '@/utils/StyleUtil';

const Search = () => {
    const router = useRouter();
    const setIsSearching = useSetRecoilState(isSearchingState);

    const onClickSearch = () => {
        setIsSearching(false);

        router.push('/ina/search');
    };

    return (
        <SearchContainer onClick={onClickSearch}>
            <SvgSelector svg="search" width={20} height={20} stroke="#888888" strokeWidth={1.4} />
            <SearchText>검색어를 입력해주세요</SearchText>
        </SearchContainer>
    );
};

const SearchContainer = styled.div`
    ${({ theme }) => theme.flex.flexOnly}
    position: relative;
    align-items: center;
    height: 50px;
    border-radius: 10px;
    background-color: #fbfbfb;
    //margin: -8px 20px 0 20px;
    //bottom: 20px;
    top: 149px;

    padding-left: 14px;
    z-index: 2;
    width: 100%;
`;

const SearchText = styled.div`
    ${FontStyle(14, 22, '400', '#888888', -1)}
    margin-left: 5px;
`;

export default Search;
